import React from "react";
import { NavLink } from "react-router-dom";

function Header({ onHomeClick }) {
    return (
        <header className="bg-light py-2">
            <nav className="container d-flex justify-content-between align-items-center">
                {/* Wrap h1 with NavLink to make it clickable */}
                <NavLink to="/" className="m-0" style={{ fontSize: '1.25rem', textDecoration: 'none', color: '#ffffff' }} onClick={onHomeClick}>
                    <h1 className="m-0">Dr. Amulya Kutikuppala</h1>
                </NavLink>

                <ul className="nav m-0">
                    <li className="nav-item">
                        <NavLink
                            to="/"
                            className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
                            onClick={onHomeClick} // Trigger celebrate animation when "Home" is clicked
                        >
                            Home
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink
                            to="/about"
                            className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
                        >
                            About me
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink
                            to="/resume"
                            className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
                        >
                            Resume
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink
                            to="/research"
                            className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
                        >
                            Research
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink
                            to="/services"
                            className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
                        >
                            Previous Experience
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink
                            to="/contact"
                            className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
                        >
                            Contact
                        </NavLink>
                    </li>
                </ul>
            </nav>
        </header>
    );
}

export default Header;
